import {
  fetchChapterContentRequest,
  fetchChapterRequest,
  fetchEpisodeChaptersRequest,
  fetchTrailerContentRequest,
} from '@/requests';
import { Chapter, ChapterUrl, ComplianceType } from '@/types';

import { postgrestApi } from '../postgrest-api';
import { selectSessionUserId } from '../session';
import { RootState } from '../store';
import { transformChapter, transformChapterUrl } from './chapters-api.utils';

type FetchChapterParams = {
  chapterId: string;
  compliance: ComplianceType;
};

type FetchEpisodeChaptersParams = {
  episodeId: string;
  compliance: ComplianceType;
};

type FetchChapterUrlsParams = {
  episodeId: string;
  compliance: ComplianceType;
};

export const chaptersApi = postgrestApi.injectEndpoints({
  endpoints: builder => ({
    fetchChapter: builder.query<Chapter | undefined, FetchChapterParams>({
      query: fetchChapterRequest,
      transformResponse: (data: unknown[]) =>
        data[0] ? transformChapter(data[0]) : undefined,
      keepUnusedDataFor: 3600,
    }),
    fetchEpisodeChapters: builder.query<Chapter[], FetchEpisodeChaptersParams>({
      query: fetchEpisodeChaptersRequest,
      transformResponse: (data: unknown[]) =>
        data.map(chapter => transformChapter(chapter)),
    }),
    fetchChapterURLs: builder.query<ChapterUrl[], FetchChapterUrlsParams>({
      queryFn: async (
        { episodeId, compliance },
        redux,
        extraOptions,
        baseQuery,
      ) => {
        const userId = selectSessionUserId(redux.getState() as RootState);
        const request = userId
          ? fetchChapterContentRequest
          : fetchTrailerContentRequest;

        const { data: chapterUrls, error } = await baseQuery(
          request({ episodeId }),
        );

        if (error) return { error };
        return {
          data: (chapterUrls as unknown[]).map(c =>
            transformChapterUrl(c, compliance),
          ),
        };
      },
    }),
  }),
});

export const {
  useFetchChapterQuery,
  useFetchChapterURLsQuery,
  useFetchEpisodeChaptersQuery,
} = chaptersApi;
